import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './disable_recurrent.component.html'
})
export class DisableRecurrentModalComponent extends BaseSupportModalComponent {
	siteId: string;
	recurrentProfiles: string[];
	domainUrl: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите отменить подписк(и) у сайта ${this.domainUrl}?`)) {
			for(const recurrentProfile of this.recurrentProfiles) {
				await this.supportService.disableRecurrentProfile(this.siteId, recurrentProfile, this.comment).toPromise();
			}
			
			this.execute();
		}
	}
}
